import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from '@picsio/ui';
import { Subtitle } from '@picsio/icons';
import Logger from '../../services/Logger';
import localization from '../../shared/strings';
import Tooltip from '../Tooltip';
import { LocalStorage } from '../../shared/utils';
import { navigate } from '../../helpers/history';
import { LOCAL_STORAGE_VIEW_KEY } from '../TranscriptPanel/components/TranscriptList/TranscriptList';

function Transcription({ assetId }) {
  const handleClickItem = (event) => {
    event.preventDefault();
    Logger.log('User', 'ThumbnailTranscriptClick');
    LocalStorage.set(LOCAL_STORAGE_VIEW_KEY, 'transcript');
    navigate(`/preview/${assetId}#videoAi`);
  };
  return (
    <Tooltip content={localization.CATALOG_ITEM.tooltipGoToTranscription} placement="top">
      <div
        className={cn('catalogItem__transcription')}
        onClick={handleClickItem}
        onKeyPress={handleClickItem}
        tabIndex={0}
        role="button"
      >
        <Icon size="md">
          <Subtitle />
        </Icon>
      </div>
    </Tooltip>
  );
}

Transcription.propTypes = {
  assetId: PropTypes.string.isRequired,
};

export default memo(Transcription);
